// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input {
  display: inline-block;
  position: relative;
  overflow: hidden;
  width: 100%;
  font-family: "Roboto", sans-serif;
  transition: all 0.3s ease;
  padding: 1px;
  border-radius: 8.485px;
  background: #2B2B2B;
}
.input:hover:not(:focus-within) {
  background: rgba(81, 86, 91, 0.45);
}
.input label {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}
.input input {
  position: relative;
  display: inline-block;
  width: 100%;
  padding: 22px 50px 10px 23px;
  background: var(--primary-color);
  outline: none;
  border-radius: 8.485px;
  z-index: 2;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  letter-spacing: 1.95px;
  font-size: 13px;
  line-height: 149.68%;
  color: #F4F4F4;
  border: none;
  transition: all 0.3s ease;
}
.input input:focus ~ .input__label, .input input:not(:placeholder-shown) ~ .input__label {
  top: 8px;
  transform: translateY(0);
  font-size: 11px;
  color: #F4F4F4;
}
.input__label {
  position: absolute;
  left: 23px;
  top: 50%;
  transform: translateY(-50%);
  font-weight: 400;
  letter-spacing: 1.95px;
  font-size: 15px;
  color: #BBB7B7;
  transition: all 0.2s ease-out;
  z-index: 3;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}
.input__message {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--primary-color);
  border-radius: 8.485px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  padding-left: 49px;
}
.input__message.active {
  opacity: 1;
  visibility: visible;
}
.input__message-text {
  color: #BBB7B7;
  font-family: "Roboto", sans-serif;
  font-size: 15px;
  font-weight: 700;
}
.input.error input {
  box-shadow: inset 0 0 0 1px #DB3522;
}
.input.error .input__label {
  color: #DB3522 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/InputGradient/Input.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,iCAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;AADF;AAGE;EACE,kCAAA;AADJ;AAIE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAFJ;AAKE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EAGA,4BAAA;EACA,gCC/BG;EDgCH,aAAA;EACA,sBAAA;EACA,UAAA;EACA,iCAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;AALJ;AAUM;EACE,QAAA;EACA,wBAAA;EACA,eAAA;EACA,cAAA;AARR;AAaE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,6BAAA;EACA,UAAA;EACA,oBAAA;EACA,yBAAA;UAAA,iBAAA;AAXJ;AAcE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,gCC7EG;ED8EH,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAZJ;AAcI;EACE,UAAA;EACA,mBAAA;AAZN;AAeI;EACE,cAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;AAbN;AAkBI;EACE,mCAAA;AAhBN;AAkBI;EACE,yBAAA;AAhBN","sourcesContent":["@import '../../../styles/_variables';\r\n\r\n.input {\r\n  display: inline-block;\r\n  position: relative;\r\n  overflow: hidden;\r\n  width: 100%;\r\n  font-family: \"Roboto\", sans-serif;\r\n  transition: all 0.3s ease;\r\n  padding: 1px;\r\n  border-radius: 8.485px;\r\n  background: #2B2B2B;\r\n\r\n  &:hover:not(:focus-within) {\r\n    background: rgba(81, 86, 91, 0.45);\r\n  }\r\n\r\n  label {\r\n    position: relative;\r\n    display: block;\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  input {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 100%;\r\n    // Увеличили верхний отступ (22px) и уменьшили нижний (10px),\r\n    // чтобы текст был смещен вниз, освобождая место для метки\r\n    padding: 22px 50px 10px 23px;\r\n    background: $main;\r\n    outline: none;\r\n    border-radius: 8.485px;\r\n    z-index: 2;\r\n    font-family: \"Roboto\", sans-serif;\r\n    font-weight: 400;\r\n    letter-spacing: 1.95px;\r\n    font-size: 13px;\r\n    line-height: 149.68%;\r\n    color: #F4F4F4;\r\n    border: none;\r\n    transition: all 0.3s ease;\r\n\r\n    // Когда инпут в фокусе или в нем есть текст (не пустой плейсхолдер)\r\n    &:focus,\r\n    &:not(:placeholder-shown) {\r\n      & ~ .input__label {\r\n        top: 8px;\r\n        transform: translateY(0);\r\n        font-size: 11px;\r\n        color: #F4F4F4;\r\n      }\r\n    }\r\n  }\r\n\r\n  &__label {\r\n    position: absolute;\r\n    left: 23px;\r\n    top: 50%;\r\n    transform: translateY(-50%); // Идеальное центрирование по вертикали\r\n    font-weight: 400;\r\n    letter-spacing: 1.95px;\r\n    font-size: 15px;\r\n    color: #BBB7B7;\r\n    transition: all 0.2s ease-out;\r\n    z-index: 3;\r\n    pointer-events: none; // Клик проходит сквозь текст в поле ввода\r\n    user-select: none;\r\n  }\r\n\r\n  &__message {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: $main;\r\n    border-radius: 8.485px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 4;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transition: all 0.3s ease;\r\n    padding-left: 49px;\r\n\r\n    &.active {\r\n      opacity: 1;\r\n      visibility: visible;\r\n    }\r\n\r\n    &-text {\r\n      color: #BBB7B7;\r\n      font-family: \"Roboto\", sans-serif;\r\n      font-size: 15px;\r\n      font-weight: 700;\r\n    }\r\n  }\r\n\r\n  &.error {\r\n    input {\r\n      box-shadow: inset 0 0 0 1px #DB3522; // Используем box-shadow вместо border, чтобы не прыгала верстка\r\n    }\r\n    .input__label {\r\n      color: #DB3522 !important;\r\n    }\r\n  }\r\n}","$main: var(--primary-color);\r\n$accent:  var(--accent-color);\r\n$additional: var(--additional-color);\r\n$primary: #131313;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
